import {HardwareDetailItem, poPrepDiagram} from "./HardwarePrepTable";
import {PrepExporter} from "../../../project/shopdrawing/hardware/prepCanvas/PrepCanvas";
import {groupByArr, orderByStrAscending} from "nate-react-api-helpers";
import {api} from "../../../../api/API";

export type PrepDiagram = {
    name: string;
    url: string;
    linkRef?: string;
}

export async function makeHwPrepDiagrams(input: HardwareDetailItem[]) {

    const element = document.createElement("div")
    document.body.appendChild(element);

    const combined = groupByArr(input, r => {
        const type = r.isPair ? "type: pair" : "type: single"
        const deadbolt = r.hasDeadbolt ? "deadbolt: yes" : "deadbolt: no";

        let cutDown = "cutDown: none";
        if(r.cutDown) {
            cutDown = `cutDown: ${r.cutDown.overCutDoor} / ${r.cutDown.underCutDoor} / ${r.cutDown.underCutFrame}`
        }

        const hingeQty = "hingeQty: " + r.manager.getHingeQty();

        return `${type}-pair kind: ${r.pairSplitKey}-${deadbolt}-${cutDown}-${hingeQty}:v2`;
    });

    // sort to keep order consistent
    orderByStrAscending(combined, v => v.key);

    try {
        const exp = new PrepExporter(element);

        const out = await Promise.all(combined.map(async (v, index) => {
            const cfg = v.values[0];

            let rs = await api.hardware.makePrepImage({
                key: v.key,
            })

            if(rs.status === "key-missing") {
                cfg.manager.calculate();
                const img = await exp.render(cfg.manager, "both");

                rs = await api.hardware.makePrepImage({
                    key: v.key,
                    file: img,
                })

                if(rs.status === "key-missing") throw new Error("Hardware Prep Key still missing after upload");
            }

            let name = alpha[index];
            v.values.forEach(itm => itm.prepDiagramName = name)

            return {
                linkRef: poPrepDiagram(name),
                name: name,
                url: rs.url,
            }
        }));

        return out;
    } finally {
        element.remove();
    }
}

const alpha = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";